import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';

import KioskLoginForm from '../../containers/Login/KioskLoginForm';
import { kioskLoginRequest } from '../../redux/modules/auth/auth-middleware';
import Message from '../../containers/Message/Message';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';
import { retrieveMessage } from '../../redux/modules/system-shared/message-bar-action-creator';


class KioskManagerLoginPage extends Component {
  constructor(props, context) {
    super(props, context);
    const parsedQueryString = QueryString.parse(this.props.location.search);
    let redirectTo = '/kioskQuestionnaires';
    if (parsedQueryString.redirect) {
      redirectTo = parsedQueryString.redirect + '?isAutoRedirect=true';
      Object.keys(parsedQueryString).forEach((param) => {
        if (param !== 'redirect') {
          const value = parsedQueryString[param];
          redirectTo += '&' + param + '=' + value;
        }
      });
    }

    this.state = {
      redirectTo,
    };
  }

  UNSAFE_componentWillMount = () => {
    const { dispatch } = this.props;
    dispatch(retrieveMessage());
    dispatch(setIsDedicatedWorkflow(false));
  }

  handleLogin = (creds) => {
    this.props.dispatch(kioskLoginRequest(creds, this.state.redirectTo));
  };

  render() {
    return (
      <div>
        <Message />
        <div className="content">
          <div className="box-content content-center-outer">
            <KioskLoginForm handleLogin={this.handleLogin} />
          </div>
        </div>
      </div>
    );
  }
}

KioskManagerLoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  location: ownProps.location,
});

export default connect(mapStateToProps)(KioskManagerLoginPage);